import { Model } from '@shared/models/model';
import { WalletTransaction } from './wallet-transaction.model';
import { Expose } from 'class-transformer';

export class WalletTransactionResponse extends Model {
  @Expose() count: number;
  @Expose() transactions: WalletTransaction[] = [];
}
